import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";

const apiURL = "multi-asset-programme-template";

const api = axios.create({
	baseURL: `${url}`,
	...AuthHeader,
});

export const getMultiAssetProgrammeTemplate = async (
	tenantKey: any,
	filter: any = {}
) => {
	try {
		const response = await api.get(
			`/${tenantKey}/${apiURL}/get_project_template`,
			{
				params: {
					filter: JSON.stringify(filter),
				},
			}
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const getPhasesFromMultiAssetOperationTemplate = async (
	tenantKey: any,
	template_id: string,
	operation_id: string
) => {
	try {
		const response = await api.get(
			`/${tenantKey}/${apiURL}/get_phases_from_operation_template`,
			{
				params: {
					template_id: template_id,
					operation_id: operation_id,
				},
			}
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const addMultiAssetProjectTemplate = async (
	tenantKey: string,
	data: any,
	userData: any
) => {
	try {
		const request_body = {
			data: data,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/add_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const addMultiAssetOperationTemplate = async (
	tenantKey: string,
	template_id: string,
	data: any,
	userData: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			template_id: template_id,
			data: data,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/add_operation_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const addPhaseInMultiAssetProjectTemplate = async (
	tenantKey: string,
	template_id: string,
	data: any,
	userData: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			template_id: template_id,
			data: data,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/add_phase_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateMultiAssetProjectTemplate = async (
	tenantKey: string,
	id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			filter: { _id: id },
			data: data,
			user: userData,
			initialData: initialData,
			formList: formList,
			options: { upsert: true, new: true },
		};
		const response = await api.put(
			`/${tenantKey}/${apiURL}/update`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateMultiAssetOperationTemplate = async (
	tenantKey: string,
	parent_id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			filter: { _id: parent_id },
			data: data,
			user: userData,
			initialData: initialData,
			formList: formList,
		};
		console.log("update operation template request body: ", request_body);
		const response = await api.put(
			`/${tenantKey}/${apiURL}/update_operation_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updatePhaseInMultiAssetProjectTemplate = async (
	tenantKey: string,
	parent_id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			filter: { _id: parent_id },
			data: data,
			user: userData,
			initialData: initialData,
			formList: formList,
		};
		const response = await api.put(
			`/${tenantKey}/${apiURL}/update_phase_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const deleteMultiAssetProjectTemplate = async (
	tenantKey: string,
	_id: string,
	userData: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			filter: { _id: _id },
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/delete_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const deleteMultiAssetOperationTemplate = async (
	tenantKey: string,
	parent_id: string,
	operation_id: string,
	userData: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			filter: { _id: parent_id },
			operation_id: operation_id,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/delete_operation_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const deletePhaseInMultiAssetProjectTemplate = async (
	tenantKey: string,
	parent_id: string,
	phase_id: string,
	userData: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			filter: { _id: parent_id },
			phase_id: phase_id,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/delete_phase_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const addTaskInPhase = async (
	tenantKey: string,
	template_id: string,
	phase_id: string,
	data: any,
	userData: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			phase_id: phase_id,
			data: data,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/add_task_in_phase`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const addTaskInOperation = async (
	tenantKey: string,
	template_id: string,
	operation_id: string,
	phase_id: string,
	data: any,
	userData: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			operation_id: operation_id,
			data: { phase_id: phase_id, ...data },
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/add_task_in_operation`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const addDeliverableInProjectTemplate = async (
	tenantKey: string,
	template_id: string,
	phase_id: string,
	task_id: string,
	data: any,
	userData: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			template_id: template_id,
			phase_id: phase_id,
			task_id: task_id,
			data: data,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/add_deliverable_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const addDeliverableInOperationTemplate = async (
	tenantKey: string,
	template_id: string,
	operation_id: string,
	task_id: string,
	data: any,
	userData: any
) => {
	try {
		const request_body = {
			tenant_key: tenantKey,
			template_id: template_id,
			operation_id: operation_id,
			task_id: task_id,
			data: data,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/add_deliverable_in_operation_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateTaskInPhase = async (
	tenantKey: string,
	template_id: string,
	phase_id: string,
	task_id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any,
	extraAuditLog: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			phase_id: phase_id,
			task_id: task_id,
			data: data,
			user: userData,
		};
		const response = await api.put(
			`/${tenantKey}/${apiURL}/update_task_in_phase`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateTaskInOperation = async (
	tenantKey: string,
	template_id: string,
	operation_id: string,
	task_id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any,
	extraAuditLog: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			operation_id: operation_id,
			task_id: task_id,
			data: data,
			user: userData,
		};
		const response = await api.put(
			`/${tenantKey}/${apiURL}/update_task_in_operation`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const deleteTaskInProjectTemplate = async (
	tenantKey: string,
	template_id: string,
	phase_id: string,
	task_id: string,
	userData: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			phase_id: phase_id,
			task_id: task_id,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/delete_task_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const deleteTaskInOperationTemplate = async (
	tenantKey: string,
	template_id: string,
	operation_id: string,
	task_id: string,
	userData: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			operation_id: operation_id,
			task_id: task_id,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/delete_task_in_operation_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateDeliverableInProjectTemplate = async (
	tenantKey: string,
	template_id: string,
	phase_id: string,
	task_id: string,
	deliverable_id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			phase_id: phase_id,
			task_id: task_id,
			deliverable_id: deliverable_id,
			data: data,
			user: userData,
		};
		const response = await api.put(
			`/${tenantKey}/${apiURL}/update_deliverable_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateDeliverableInOperationTemplate = async (
	tenantKey: string,
	template_id: string,
	operation_id: string,
	task_id: string,
	deliverable_id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			operation_id: operation_id,
			task_id: task_id,
			deliverable_id: deliverable_id,
			data: data,
			user: userData,
		};
		const response = await api.put(
			`/${tenantKey}/${apiURL}/update_deliverable_in_operation_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const deleteDeliverableInProjectTemplate = async (
	tenantKey: string,
	template_id: string,
	phase_id: string,
	task_id: string,
	deliverable_id: string,
	userData: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			phase_id: phase_id,
			task_id: task_id,
			deliverable_id: deliverable_id,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/delete_deliverable_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const deleteDeliverableInOperationTemplate = async (
	tenantKey: string,
	template_id: string,
	operation_id: string,
	task_id: string,
	deliverable_id: string,
	userData: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			operation_id: operation_id,
			task_id: task_id,
			deliverable_id: deliverable_id,
			user: userData,
		};
		const response = await api.post(
			`/${tenantKey}/${apiURL}/delete_deliverable_in_operation_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const reorderPhasesInMultiAssetProjectTemplate = async (
	tenantKey: string,
	template_id: string,
	data: any,
	initialData: any,
	userData: any,
	formList: any
) => {
	try {
		const request_body = {
			template_id: template_id,
			data: data,
			user: userData,
			initialData: initialData,
			formList: formList,
		};
		const response = await api.put(
			`/${tenantKey}/${apiURL}/reorder_phases_in_project_template`,
			request_body
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};
